import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import type { Stats } from '@/types/api';

/**
 * Catalogue statistics. Only fetched when signed in — the endpoint answers 401 to anonymous
 * callers, and the page is guarded, so `enabled` gates the request rather than letting it fail.
 */
export function useStatsQuery(enabled: boolean): UseQueryResult<Stats, Error> {
  return useQuery<Stats, Error>({
    queryKey: queryKeys.stats(),
    queryFn: ({ signal }) => apiClient.getStats(signal),
    enabled,
    // Aggregates drift slowly; a few minutes of staleness is fine and avoids re-scanning on
    // every visit to the page.
    staleTime: 5 * 60 * 1000,
  });
}
